module.exports = __webpack_public_path__ + "static/img/eye-512.3b7c4dc5.png";